import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BoardSummary } from 'app/trello/models/board-summary';
import { BoardSummaryMapper } from 'app/trello/services/board-summary-mapper';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardSummaryFetcher {

  constructor(
    private readonly boardSummaryMapper: BoardSummaryMapper,
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
  ) {
  }

  public fetch(
    from: string,
    to: string,
    now: string,
  ): Observable<BoardSummary> {

    console.log('Fetching board summary statistics', [from, to, now]);

    const url = `${environment.apiRoot}${environment.endpoints.boardSummaryStatistics}`;

    const queryParameters =
      this.buildQueryParameters(from, to, now);

    return this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.get<BoardSummary>(
            url,
            {
              headers: {Authorization: `Bearer ${userToken}`},
              params: queryParameters,
            },
          ),
        ),
        catchError((error: any) => {

          console.error('An error occurred fetching board summary statistics:', error);

          return this.requestErrorThrower.throwError(error);
        }),
        switchMap((boardSummary: BoardSummary) => {

          return this.boardSummaryMapper.map(boardSummary);
        }),
      );
  }

  private buildQueryParameters(
    from: string,
    to: string,
    now: string,
  ): { from: string; to: string; now: string; } {

    return {
      from,
      to,
      now,
    };
  }

}
